import React from 'react';

import styled from 'styled-components';

import { useProductContext } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';
import { useReviewsMetaDataQuery } from '~/techstyle-shared/react-products';

const FitWrapper = styled.div`
  ${({ theme }) => theme.selectorStyles.selectorLabelStyle}
`;

const FitSizeText = styled.span`
  ${({ theme }) => theme.selectorStyles.fitSelectorValue}
`;

// helper function to abstract how overallFit is derived
function getOverallFit(fit) {
  return {
    runsSmall: fit < -0.5,
    runsLarge: fit > 0.5,
    trueToSize: fit >= -0.5 && fit <= 0.5,
  };
}

export default function ProductDetailFitCallout() {
  const { groupCode } = useProductContext();
  const { data, loading } = useReviewsMetaDataQuery(
    { groupCode },
    { ssr: false, skip: !groupCode }
  );

  if (loading) {
    return null;
  }

  const { overallFit, counts: { reviewCount } = {} } =
    data?.reviewsMetaData ?? {};

  const overallFitAvailable = reviewCount > 0 && !isNaN(overallFit);

  if (!overallFitAvailable) {
    return null;
  }

  const { runsLarge, runsSmall, trueToSize } = getOverallFit(overallFit);

  return (
    <FitWrapper>
      <FormattedMessage id="site_product_page.fit" defaultMessage="Fit:" />
      &nbsp;
      <FitSizeText>
        {runsSmall && (
          <FormattedMessage
            id="site_product_page.fit_runs_small"
            defaultMessage="Runs Small"
          />
        )}
        {trueToSize && (
          <FormattedMessage
            id="site_product_page.fit_true_to_size"
            defaultMessage="True to Size"
          />
        )}
        {runsLarge && (
          <FormattedMessage
            id="site_product_page.fit_runs_large"
            defaultMessage="Runs Large"
          />
        )}
      </FitSizeText>
    </FitWrapper>
  );
}
